import { Link, useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import ProgressSteps from "../../../components/ProgressSteps";
import { useState } from "react";
import { signup } from "../../../api/authProfessional";

export default function ProSignupDocument() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const onValidate = async () => {
    if (loading) return;
    setLoading(true);
    setError("");
    try {
      const raw = localStorage.getItem("pro.signup");
      const credRaw = sessionStorage.getItem("agbaza.pro.signup.credentials");
      if (!raw || !credRaw) {
        setError("Session d'inscription incomplete. Recommencez depuis le debut.");
        setLoading(false);
        return;
      }
      const s = JSON.parse(raw) as Record<string, unknown>;
      const cred = JSON.parse(credRaw) as { email: string; password: string; confirmPassword: string };
      const etablissementIds = Array.isArray(s.etablissement_ids) ? (s.etablissement_ids as string[]) : [];
      const specialite = String(s.specialite ?? s.profil ?? "").trim();
      const specialiteAutre = String(s.specialite_autre ?? "").trim();
      const profileData = {
        nip: String(s.anip ?? "").trim(),
        nom: String(s.nom ?? "").trim(),
        prenom: String(s.prenom ?? "").trim(),
        specialite,
        ...(specialite === "autre" ? { specialite_autre: specialiteAutre } : {}),
        departement: String(s.departement ?? "").trim(),
        commune: String(s.commune ?? "").trim(),
        arrondissement: String(s.arrondissement ?? "").trim(),
        ...(etablissementIds.length > 0 ? { etablissement_ids: etablissementIds } : {}),
      };
      if (
        profileData.nip.length < 5 ||
        profileData.nom.length < 2 ||
        profileData.prenom.length < 2 ||
        profileData.specialite.length < 2 ||
        (specialite === "autre" && specialiteAutre.length < 2) ||
        profileData.departement.length < 2 ||
        profileData.commune.length < 2 ||
        profileData.arrondissement.length < 2
      ) {
        setError("Donnees profil invalides. Verifiez les etapes precedentes.");
        setLoading(false);
        return;
      }
      const result = await signup({
        email: cred.email,
        password: cred.password,
        confirmPassword: cred.confirmPassword,
        profileData,
      });
      if (!result.ok) {
        setError(result.message || "Inscription impossible.");
        setLoading(false);
        return;
      }
      sessionStorage.removeItem("agbaza.pro.signup.credentials");
      localStorage.removeItem("pro.signup");
      navigate("/professionnel/inscription/succes", { replace: true, state: { apiSuccess: true } });
    } catch {
      setError("Erreur lors de l'inscription.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="relative h-screen overflow-hidden">
      <img src={import.meta.env.BASE_URL + "maps-reset-side.jpg"} alt="pro-signup-docs" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 bg-black/30" />

      <div className="absolute inset-0 z-10 px-4 md:px-8 py-6 md:py-8 flex">
        <div className="max-w-6xl mx-auto flex flex-col w-full">
          <div className="pl-2 md:pl-6 pt-2 md:pt-4">
            <Link to="/professionnel/inscription/etablissements" className="inline-flex items-center gap-2 text-white/90">
              <ArrowLeft size={18} /> Retour
            </Link>
          </div>

          <div className="mt-auto flex items-end justify-between gap-6 pl-2 md:pl-6 pr-4 md:pr-8 pb-4 md:pb-8">
            <div className="w-full max-w-2xl min-h-[520px] bg-white/95 backdrop-blur rounded-[12px] shadow p-8 md:p-10">
              <h1 className="text-2xl font-semibold" style={{ color: "#0B1F16" }}>
                Dernière étape pour terminer l'inscription
              </h1>

              {error && (
                <div className="mt-4 text-sm text-red-700 bg-red-50 border border-red-200 rounded-[10px] px-3 py-2">
                  {error}
                </div>
              )}

              <div className="mt-6 text-sm rounded-[10px] px-4 py-3" style={{ color: "#0B1F16", backgroundColor: "#F3F8F6", border: "1px solid #D1E2DD" }}>
                <p className="font-semibold mb-1">Pièces justificatives</p>
                <p className="text-gray-600">
                  Une fois votre compte créé, connectez-vous puis rendez-vous dans « Vérification d'identité »
                  depuis votre tableau de bord pour transmettre votre carte CIP et votre attestation
                  d'inscription à l'Ordre — c'est ce qui déclenche la vérification de votre compte.
                </p>
              </div>

              <div className="mt-6">
                <button
                  type="button"
                  className="w-full h-14 rounded-[10px] font-medium cursor-pointer disabled:opacity-60"
                  style={{ backgroundColor: !loading ? "#00553E" : "#DCEFE9", color: !loading ? "#FFFFFF" : "#7aa79a" }}
                  disabled={loading}
                  onClick={() => void onValidate()}
                >
                  {loading ? "Inscription..." : "Créer mon compte"}
                </button>
              </div>
            </div>

            <div className="hidden md:block shrink-0">
              <img src={import.meta.env.BASE_URL + "Group 5.png"} alt="agabaza-logo" className="w-auto" style={{ height: 144 }} />
            </div>
          </div>

          <div className="pl-2 md:pl-6 pt-2 md:pt-4">
            <ProgressSteps step={4} total={4} />
          </div>
        </div>
      </div>
    </div>
  );
}
